import store from "./app/store";
import Cards from "./app/components/cards"
import Events from "./app/components/events"
import Nav from "./app/components/nav";
import AppSettings from "./app/app-settings";
import Modal from "./app/components/modal";
import SearchInput from "./app/components/search";
import SubscribeEmail from "./app/components/subscribe-email";
import Accessibility from "./app/components/accessibility";
import Voting from "./app/components/voting";

(function () {
	AppSettings();
	Cards();
	Events();
	Nav();
	Modal();
	SearchInput();
	SubscribeEmail();
	Accessibility();
	Voting();
})();
